export const clickupReports = {
  "Parcel Damage Claims": {
    listId: 901308761162,
    fields: {
      client_name: "49f889b0-2dc2-499f-ba9f-77a1b749e448",
      tracking_number: "name",
      parcel_carrier: "af480c34-e733-42ee-a833-ffd17b55a07a",
      claim_type: "1d224eed-999a-4559-bbdf-2ccbf0e76cfe",
      claim_status: "9683807e-c0f3-41ae-a8c3-1ff83545ba64",
      submit_date: "7dba53f5-ebf2-42d6-b557-ea67e7fac34b",
      credit_amount: "f07f9d70-654b-4e22-aeaf-c62e27479f5a",
    },
    reportName: "parcelclaimsreport",
  },

  "Freight Claims": {
    listId: 900601565164,
    fields: {
      client_name: "5c4829a1-d4bf-4c31-ae1b-016add71f6b7",
      BOL_number: "c5086241-8e5f-47ba-934a-6db67f59285e",
      customer_PO: "7060435b-b0ff-4cc0-bf0e-904cc8670831",
      carrier: "d62c3356-0f0a-43e8-a47f-1f07af9017e7",
      units_missing_or_damaged: "0f403543-893e-4a9c-a66c-5ffde70cc529",
      value: "2b299038-c418-4c62-8078-1ec0c3b93a0e",
      status: "status.status",
    },
    reportName: "freightclaims",
  }
};
